module.exports = __webpack_public_path__ + "static/10-b28404dbfe9e45b45c0b637bba62daa8.jpeg";